module.exports = __webpack_public_path__ + "a1ad5b111f092067b468fd22af638bf6.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/festival04.jpg
// module id = 654
// module chunks = 0